<template>
  <v-dialog v-model="dialogComp" persistent max-width="500px">
    <v-card>
      <v-toolbar dense flat dark color="primary">
        <v-btn icon dark @click="cancel">
          <v-icon>close</v-icon>
        </v-btn>
        <v-toolbar-title class="pl-0">Generar progressió</v-toolbar-title>
        <v-spacer></v-spacer>

        <v-btn class="mr-4" @click="resetForm" small outlined>
          Reiniciar
        </v-btn>
        <v-btn type="submit" form="novaProgressio" small depressed light>
          Generar
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-container>
          <v-row>
            <v-form
              id="novaProgressio"
              class="my-2"
              @submit.prevent="submitForm"
              ref="form"
            >
              <v-col cols="12">
                <v-text-field
                  v-model="progressioName"
                  label="Nom progressió"
                  :rules="[v => !!v || 'Camp obligatori']"
                ></v-text-field>
              </v-col>
            </v-form>
          </v-row>
        </v-container>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import ServiceFactory from "@/services/ServiceFactory"

export default {
  data() {
    return {
      progressioName: this.nomSessio,
    }
  },
  props: {
    dialog: {
      type: Boolean,
      default: false,
    },
    nomSessio: {
      type: String,
      default: "",
    },
    idSessio: {
      type: Number,
      default: null,
    },
  },
  methods: {
    cancel() {
      this.closeDialog()
    },
    closeDialog() {
      this.$emit("toggleGeneracioProgressioDialog")
    },
    resetForm() {
      this.progressioName = this.nomSessio
    },
    validate() {
      return this.$refs.form.validate()
    },
    submitForm() {
      const ProgressioService = ServiceFactory.get("progressions")
      if (!this.validate()) {
        return
      }
      ProgressioService.createItem({
        from: "sessions",
        id_sessio: this.idSessio,
        nom_progressio: this.progressioName,
      })
        .then(() => {
          this.closeDialog()
          this.$notify({
            type: "success",
            title: this.$store.state.commonText.notification.successTitle,
            text: this.$store.state.commonText.notification.successText,
          })
        })
        .catch(error => {
          this.$notifyErrorByStatusCode(error.response.status)
        })
    },
  },
  computed: {
    dialogComp: {
      get() {
        this.resetForm()
        return this.dialog
      },
      set() {
        this.closeDialog()
      },
    },
  },
}
</script>

<style lang="scss">
.prd-dialog-spinner {
  margin-left: auto;
  margin-right: auto;
}
</style>
